import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';

// Import components
import Header from './components/Header';
import Footer from './components/Footer';
import BlobServe from './components/BlobServe';

// Import pages
import Home from './pages/Home';
import Login from './pages/Login';
import TestDashboard from './components/TestDashboard';

// Import context
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            bgcolor: 'background.default',
          }}
        >
          <Header />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/test-dashboard" element={<TestDashboard />} />
            <Route path="/blob/:hash" element={<BlobServe />} />
          </Routes>

          <Footer />
        </Box>
      </AuthProvider>
    </Router>
  );
}

export default App;